var map = {
	"./digital_twins.png": 29732,
	"./gamification.png": 59741,
	"./loyalty_coins.png": 48461,
	"./marketplace.png": 54705,
	"./membership.png": 42578,
	"./shared_ownership.png": 40571,
	"./smart_tickets.png": 54201,
	"./social.png": 96143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89465;